import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Summary from '../Summary';
import DeliverableMain from './DeliverableMain';

const DepartmentHeader = styled.div`
                        	background: #C30019;
                        	color:#FFF;
							text-align:center;
							padding: 10px;
                            width:100%;
                            .title-link{
                            
                            }
                            svg{
                                margin-right:6px;
                            }

`;

const getMonths = () => {
    let monthNames = [

        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"

    ];

    let months = [];
    let now = new Date();

    months.push({ 'name': monthNames[now.getMonth()], 'month': now.getMonth() + 1 });
    months.push({ 'name': monthNames[now.getMonth() + 1], 'month': now.getMonth() + 2 });
    months.push({ 'name': monthNames[now.getMonth() + 2], 'month': now.getMonth() + 3 });

    return months;
}
function MainBody(props) {
    const activities = useSelector(state => state.activities.filter(activity => activity.category === 'top-level'));
    const departments = useSelector(state => state.departments);

    const months = getMonths();
    return (
        <DeliverableMain departments={departments} activities={activities} />
    );
}

export default MainBody;